import React, { useState, useEffect } from "react";
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Tab1 from "./Tab1.jsx";
import { useGetPurchaseOrderListMutation } from "../../../../store/api/gateEntryApiNew";
import {
  useGetGenderOptionsQuery,
  useGetUserOptionsQuery,
  useGetSalutationOptionsQuery,
  useGetDocTypeOptionsQuery,
  useCreateContactMutation,
} from "../../../../store/api/contactapi.jsx";
import { useNavigate } from "react-router-dom";
import { usePageState } from "../../../../Hook/usePageState.jsx";
import Openinginvoiceservice from "./Openinginvoiceservice.jsx";
function OpenInvoiceCreation() {
  const [createContact, { isLoadingsix, errorsix, data }] =
    useCreateContactMutation();
  const navigate = useNavigate();

  const [tab, settab] = useState(1);
  const [res, setRes] = useState(false);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [ptype, setptype] = useState("Error");
  const [showError, setShowError] = useState(false);
  const [selected_item_data, setselected_item_data] = useState([]);
  const [selected_item_data_two, setselected_item_data_two] = useState([]);
  const [selected_item_data_three, setselected_item_data_three] = useState([]);
  const [getitem_list_data] = useGetPurchaseOrderListMutation();
  const [invoiceList, setInvoiceList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [CompanyList, setCompanyList] = useState([]);
  const [CostCenterList, setCostCenterList] = useState([]);
  // ---- STATIC DATA ----
  const staticCompany = [
    { id: 1, name: "Stackerbee" },
    { id: 2, name: "Google" },
    { id: 3, name: "Microsoft" },
  ];

  const staticInvoiceType = [
    { id: 1, name: "Regular" },
    { id: 2, name: "Proforma" },
    { id: 3, name: "International" },
  ];
  const staticCostCenter = [
    { id: 1, name: "Regular" },
    { id: 2, name: "Proforma" },
    { id: 3, name: "International" },
  ];
  const staticItemList = [
    {
      Party: "Google Pvt Ltd",
      PostingDate: "2025-01-10",
      DueDate: "2025-01-20",
      ItemName: "Cloud Subscription",
      OutstandingAmount: "12000",
    },
    {
      Party: "Microsoft India",
      PostingDate: "2025-02-05",
      DueDate: "2025-02-15",
      ItemName: "Azure Credits",
      OutstandingAmount: "18000",
    },
    {
      Party: "Stackerbee",
      PostingDate: "2025-03-01",
      DueDate: "2025-03-10",
      ItemName: "MR Project",
      OutstandingAmount: "25000",
    },
  ];

  // ---- SET STATIC DATA ----
  useEffect(() => {
    setCompanyList(staticCompany);
    setInvoiceList(staticInvoiceType);
    setCostCenterList(staticCostCenter);
  }, [staticCompany, staticInvoiceType]);

  const [formData, setFormData] = useState({
    solution: "",
    firstname: "",
    lastname: "",
    gender: "",
    userid: "",
    address: "",
    designation: "",
    company_name: "",
    status: "",
    is_google: false,
    unsubscribed: false,
    department: "",
    is_primary_contact: false,
    is_billing_contact: false,
  });

  const pageStateDefault = {
    tab: 1,
    Company: "",
    InvoiceType: "",
    CreateMissingParty: false,
    CostCenter: "",
  };
  const [pageState, setPageState] = usePageState(
    `Create Opening Invoice Creation Tool`,
    pageStateDefault
  );

  const handleInputChange1 = (f, v) => {
    setPageState({ ...pageState, [f]: v });
  };
  const validateForm = () => {
    const newErrors = {};

    // Tab1 validations
    if (!pageState.Company) newErrors.Company = "Company is required";
    if (!pageState.InvoiceType)
      newErrors.InvoiceType = "InvoiceType is required";
    if (!pageState.CreateMissingParty)
      newErrors.lastname = "CreateMissingParty is required";
    if (!pageState.CostCenter) newErrors.gender = "CostCenter is required";

    setErrors(newErrors);

    // return false if errors exist
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      // show first error in alert
      const firstErrorKey = Object.keys(errors)[0];
      const firstErrorMsg = errors[firstErrorKey];
      setError(firstErrorMsg || "");
      setptype("Error");
      setShowError(true);
      return;
    }

    const payload = {
      first_name: pageState.firstname,
      last_name: pageState.lastname,
      email_id: pageState.userid,
      status: pageState.status,
      salutation: pageState.solution,
      designation: pageState.designation,
      gender: pageState.gender,
      mobile_no:
        selected_item_data_two?.find((e) => e.is_primary_mobile)?.number || "",
      company_name: pageState.company_name,
      is_primary_contact: pageState.is_primary_contact ? 1 : 0,
      is_billing_contact: pageState.is_billing_contact ? 1 : 0,
      department: pageState.department,
      unsubscribed: pageState.unsubscribed ? 1 : 0,
      email_ids: selected_item_data.map((e) => ({
        email_id: e.email,
        is_primary: e.is_primary ? 1 : 0,
      })),
      phone_nos: selected_item_data_two.map((e) => ({
        phone: e.number,
        is_primary_phone: e.is_primary_phone ? 1 : 0,
        is_primary_mobile_no: e.is_primary_mobile ? 1 : 0,
      })),
      links: selected_item_data_three.map((e) => ({
        link_doctype: e.Link_Document_Type,
        link_name: e.Link_Name,
      })),
    };

    try {
      const response = await createContact(payload).unwrap();
      // console.log("Contact Created:", response);
      setPageState(pageStateDefault);
      setError("Contact created successfully!");
      setptype("Success");
      setShowError(true);
      setTimeout(() => {
        navigate("/master/contact-list");
      }, 1500);
    } catch (err) {
      console.error("Creation Failed:", err);
      setError("Failed to create contact.");
      setptype("Error");
      setShowError(true);
    }
  };

  return (
    <>
      <FormLayoutTwo
        title="Create Opening Invoice Creation Tool"
        breadcrumbs={[
          { label: "Master" },
          {
            label: "Create Opening Invoice Creation Tool ",
            url: "/master/Invoice-Creation/Create-opening-invoice-Creation-Tool/CreateInvoiceCreation",
          },
        ]}
        status={res ? "Draft" : "New"}
        actionButtons={
          <>
            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: "2px", height: "28px" }}
              onClick={handleSubmit}
              iconSize={12}
            >
              Create Invoices
            </Button>

            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: "21px" }}
            />
          </>
        }
      >
        <div
          className=""
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul
                className="nav nav-tabs"
                style={{ color: "white", border: "none" }}
              >
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a
                    className={
                      tab === 1
                        ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                        : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                    }
                    onClick={() => settab(1)}
                    href="javascript:void(0);"
                  >
                    General Details{" "}
                    {tab === 1 ? (
                      <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                    ) : (
                      <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                    )}
                  </a>
                </li>
              </ul>
              <div
                className="d-flex align-items-center mb-2 px-3"
                style={{ gap: "2px", fontSize: "12px" }}
              >
                <span style={{ position: "relative", top: "-1px" }}>
                  <GetIcon
                    className="text-[#4B002B]"
                    iconName="CgAttachment"
                    size={12}
                  />
                </span>
                <span className="fw-semibold" style={{ color: "#4B002B" }}>
                  Attachments
                </span>
              </div>
            </div>
          </div>

          <div className=" " style={{ background: "" }}>
            <div className="row">
              <div className="col-12">
                <div className="sidebarbox m-0">
                  <Tab1
                    CompanyList={CompanyList}
                    invoiceList={invoiceList}
                    userList={userList}
                    pageState={pageState}
                    handleChange={handleInputChange1}
                    errors={errors}
                    CostCenterList={CostCenterList}
                    list_data={staticItemList}
                    setselected_item_data={setselected_item_data}
                    onInputChange={(f, v) =>
                      setPageState({ ...pageState, [f]: v })
                    }
                  />
                </div>

                {/* <div className="sidebarbox m-0">
                                    <Tab2
                                        errors={errors}


                                        formData={formData}
                                        onInputChange={handleInputChange}
                                    />
                                </div> */}
              </div>
            </div>
          </div>
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayoutTwo>
    </>
  );
}

export default OpenInvoiceCreation;
